import { useSelector } from 'react-redux'
import DigitalAssetSelectors from 'modules/domain/digitalAsset/selectors'
import { Progress, ResourceHook } from 'modules/types'
import DigitalAssetActions from 'modules/domain/digitalAsset/duck'
import { DigitalAsset, DigitalAssetListRequestFilter, DigitalAssetMetaData } from 'modules/domain/digitalAsset/types'
import { useAction, useDidMount, usePageQuery } from '@agro-club/frontend-shared'

export const useDigitalAssetList: ResourceHook<
  DigitalAsset[],
  [{ filter?: DigitalAssetListRequestFilter; pageSize?: number }]
> = ({ filter, pageSize }: { filter?: DigitalAssetListRequestFilter; pageSize?: number } = {}) => {
  const progress = useSelector(DigitalAssetSelectors.listFetchProgress)
  const list = useSelector(DigitalAssetSelectors.digitalAssetList)
  const page = usePageQuery()
  const sorting = useSelector(DigitalAssetSelectors.sorting)
  const params: { filter?: DigitalAssetListRequestFilter; page?: number; pageSize?: number; sorting?: any } = {}
  if (filter) params.filter = filter
  if (page) params.page = page
  if (pageSize !== undefined) params.pageSize = pageSize
  if (sorting.sort_field) params.sorting = sorting
  const fetchAction = useAction(DigitalAssetActions.listRequested, page ? { page, sorting } : { sorting })

  useDidMount(() => {
    if (progress !== Progress.SUCCESS) {
      fetchAction()
    }
  })

  return [progress, list]
}

export const useDigitalAsset: ResourceHook<DigitalAsset, [string]> = (id: string) => {
  const meta = useSelector((state) => DigitalAssetSelectors.meta(state, id))
  const digitalAsset = useSelector((state) => DigitalAssetSelectors.digitalAsset(state, id))
  const fetchAction = useAction(DigitalAssetActions.itemRequested, id)

  useDidMount(() => {
    if (!digitalAsset || digitalAsset.id !== id) {
      fetchAction()
    }
  })

  return [meta.fetchProgress, digitalAsset]
}

export const useDigitalAssetMeta: ResourceHook<DigitalAssetMetaData, [string]> = (id: string) => {
  const progress = useSelector(DigitalAssetSelectors.metaFetchProgress)
  const digitalAsset = useSelector((state) => DigitalAssetSelectors.digitalAsset(state, id))
  const fetchAction = useAction(DigitalAssetActions.itemMetaDataRequested, id, digitalAsset)

  useDidMount(() => {
    if (!digitalAsset?.metadata) {
      fetchAction()
    }
  })

  return [progress, digitalAsset?.metadata]
}
